export function getVerificationOrigin() {
  if (typeof window !== "undefined" && window.location && String(window.location.origin || "").trim()) {
    return String(window.location.origin).trim().replace(/\/$/, "");
  }
  return "http://localhost:3000";
}
